import { AvailableFilters } from '@finn/ua-vehicle';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

import { CosmicMetafield, CosmicObject } from '~/types/cosmicModules';

import CosmicBlock from './CosmicBlock';

type Props = {
  cosmicObject: CosmicObject;
  nextAvailableFilters: AvailableFilters;
};

const CosmicContent = ({ cosmicObject, nextAvailableFilters }: Props) => {
  if (isEmpty(cosmicObject)) return null;

  const metafields = get(
    cosmicObject,
    'metafields',
    []
  ) as CosmicObject['metafields'];
  const metadata = get(
    cosmicObject,
    'metadata',
    {}
  ) as CosmicObject['metadata'];

  const content = metafields.map((block: CosmicMetafield) => {
    return (
      <CosmicBlock
        key={block.key}
        block={block}
        content={get(metadata, block.key, {})}
        nextAvailableFilters={nextAvailableFilters}
      />
    );
  });

  return <>{content}</>;
};

export default CosmicContent;
